<template>
  <div class="chat chat-wrapper">
    <div id="bottom-safe-space"></div>
    <template v-for="(message, index) in messages">
      <IncidentCreated
        v-if="message.type === 'incident_created'"
        v-bind:key="'m-incident-created-' + index + '-' + message.TIMESTAMP"
        :message="message"
      ></IncidentCreated>

      <PredefinedItem
        v-if="message.type === 'predefined'"
        v-bind:key="'m-predefined-' + index + '-' + message.TIMESTAMP"
        :message="message"
        :token="livestatus.TOKEN"
        :cancelReasons="
          message.data_predefined === 'cancel_element' ? cancelReasons : false
        "
      ></PredefinedItem>

      <PreformattedItem
        v-if="message.type === 'html'"
        v-bind:key="'m-preformatted-' + index + '-' + message.TIMESTAMP"
        :message="message"
      ></PreformattedItem>

      <SimpleText
        v-if="message.type === 'text'"
        v-bind:key="'m-simple-text-' + index + '-' + message.TIMESTAMP"
        :message="message"
        :messageIndex="index"
      ></SimpleText>

      <BinaryItem
        v-if="message.type === 'binary'"
        v-bind:key="'m-binary-' + index + '-' + message.TIMESTAMP"
        :message="message"
        :token="livestatus.TOKEN"
      ></BinaryItem>

      <QuestionItem
        v-if="message.type === 'question'"
        v-bind:key="'m-question-' + index + '-' + message.TIMESTAMP"
        :message="message"
      ></QuestionItem>

      <AnswerItem
        v-if="message.type === 'answer'"
        v-bind:key="'m-answer-' + index + '-' + message.TIMESTAMP"
        :message="message"
      ></AnswerItem>
    </template>

    <div
      class="new-messages"
      @click="scrollToBottom"
      v-if="showNewMessageAlert"
    >
      <oeamtc-alert>
        <template slot="contentSlot">
          Es sind neue Informationen zu Ihrem Fall verfügbar.
        </template>
      </oeamtc-alert>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import mock_messages from '@/assets/mocks/mock_messages.json';
import { OeamtcAlert } from '@oeamtc/styleguide-vuejs-lib-ui';
import {
  IncidentCreated,
  PredefinedItem,
  PreformattedItem,
  SimpleText,
  BinaryItem,
  QuestionItem,
  AnswerItem,
} from './MessageTypes';

export default {
  name: 'ChatMessages',
  props: ['livestatus'],
  components: {
    OeamtcAlert,
    IncidentCreated,
    PredefinedItem,
    PreformattedItem,
    SimpleText,
    BinaryItem,
    QuestionItem,
    AnswerItem,
  },
  data() {
    return {
      messages: [],
      // mock_messages: mock_messages,
      textMessage: '',
      cancelReasons: null,
      pollTime: 30000,
      etag: null,
      messageSending: false,
      showNewMessageAlert: false,
    };
  },
  methods: {
    loadMessagesWithToken() {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/msg/assistance/incident/${this.livestatus.TOKEN}/livestatus`
        )
        .then(
          (response) => {
            const etag = response.headers['Etag'];
            if (etag === this.etag) {
              setTimeout(this.loadMessagesWithToken, this.pollTime);
              return;
            }

            if (this.etag === null && etag !== undefined) {
              this.etag === etag;
            }

            if (
              this.messages.length <
              response.data.Livestatus.STATUSELEMENTS.length
            ) {
              if (!this.isLastMessageVisible()) {
                this.showNewMessageAlert = true;
              }
            }

            this.messages = response.data.Livestatus.STATUSELEMENTS.reverse();
            // this.messages = this.mock_messages.Livestatus.STATUSELEMENTS;
            this.cancelReasons = response.data.Livestatus.cancel_reasons;
            setTimeout(this.loadMessagesWithToken, this.pollTime);
          },
          (error) => {
            console.error(error);
            setTimeout(this.loadMessagesWithToken, this.pollTime);
          }
        );
    },
    addText() {
      if (this.textMessage) {
        this.messageSending = true;
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/msg/assistance/incident/${this.livestatus.TOKEN}/text`,
            {
              user_text: {
                text: this.textMessage,
              },
            }
          )
          .then(
            (response) => {
              this.messageSending = false;
              this.textMessage = '';
              this.messages = response.data.Livestatus.STATUSELEMENTS.reverse();
              this.cancelReasons = response.data.Livestatus.cancel_reasons;
            },
            (error) => {
              console.error(error);
            }
          );
      }
    },
    scrollToBottom() {
      const element = window.document.getElementById('bottom-safe-space');
      if (element) {
        element.scrollIntoView({ block: 'end', behavior: 'smooth' });
        this.showNewMessageAlert = false;
      }
    },
    isLastMessageVisible() {
      const elements = window.document.querySelectorAll('.chat-bubble');
      if (!elements || elements.length === 0) return;
      var rect = elements[0].getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.top + 50 <=
          (window.innerHeight || document.documentElement.clientHeight)
      );
    },
  },
  beforeMount() {
    if (this.livestatus) {
      this.messages = [...this.livestatus.STATUSELEMENTS].reverse();
      this.loadMessagesWithToken();
    }
  },
};
</script>

<style lang="scss" scoped>
.chat {
  display: flex;
  flex-direction: column-reverse;
  position: relative;
}

.send-button {
  align-self: center;
}

#bottom-safe-space {
  height: 1px;
}

.new-messages {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}
</style>
